import { connect } from 'react-redux';
import DailyPlanning from '../../components/DailyPlanning/DailyPlanning';
import { getSettings, getCurrentUserOrgUnits } from '../../actions/entities';
import { getDailyPlanningDetails, setDefaultOrgUnitForDay } from '../../actions/areas/dailyPlanning';
import { selectSelectedDate, selectSelectedTeam } from '../../reducers/areas/dailyPlanning';

const mapStateToProps = state => {
  const {
    entities: { settings, orgUnits },
  } = state;
  return {
    selectedDate: selectSelectedDate(state),
    selectedTeam: selectSelectedTeam(state),
    appSettings: settings.appSettings,
    teams: orgUnits.general.teams,
  };
};

const mapDispatchToProps = dispatch => ({
  setDefaultOrgUnitForDay: orgUnitId => dispatch(setDefaultOrgUnitForDay(orgUnitId)),
  getAppSettings: kv => {
    dispatch(getSettings(kv));
  },
  getDailyPlanningDetails: () => dispatch(getDailyPlanningDetails()),
  getAllTeams: date => dispatch(getCurrentUserOrgUnits(date)),
});

const DailyPlanningPage = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: false },
)(DailyPlanning);

export default DailyPlanningPage;
